import type { ReactNode } from 'react'
import { cn } from 'cn'
import type {
  EmbeddedImageAttachment,
  ImageUploadAttachment,
} from 'modules/community/types/post-attachment'
import { AttachmentUploadStatusEnum } from 'modules/community/types/post-attachment'

interface ImageAttachmentPreviewProps {
  className?: string
  attachment: EmbeddedImageAttachment | ImageUploadAttachment
  size?: 'original' | 'small'
}

export default function ImageAttachmentPreview({
  attachment,
  className,
  size = 'small',
}: ImageAttachmentPreviewProps): ReactNode {
  const imageSrc =
    size === 'small' && attachment.previewUrl !== ''
      ? (attachment.previewUrl ?? attachment.url)
      : attachment.url

  return (
    <div
      className={cn(
        'size-full overflow-hidden rounded-lg',
        attachment.status === AttachmentUploadStatusEnum.Uploading && `bg-bg-page`,
        className,
      )}
    >
      {!!imageSrc && (
        <img
          data-testid="attachment-preview-image"
          src={imageSrc}
          alt=""
          className="size-full object-cover transition-all md:group-hover:scale-110"
        />
      )}
    </div>
  )
}
